<template>
    <div class="pro-group">
        <div class="row">
            <div class="col-md-4 xl-50 box-col-30">
                <h4 class="product-title">share it</h4>
            </div>
            <div class="col-md-7 xl-50 box-col-70">
                <div class="product-icon">
                    <ul class="product-social">
                        <li class="d-inline-block"><a href="https://www.facebook.com" target="_blank"><i
                                    class="fa fa-facebook"></i></a></li>
                        <li class="d-inline-block"><a href="https://www.google.com/" target="_blank"><i
                                    class="fa fa-google-plus"></i></a></li>
                        <li class="d-inline-block"><a href="https://twitter.com/" target="_blank"><i
                                    class="fa fa-twitter"></i></a></li>
                        <li class="d-inline-block"><a href="https://www.instagram.com/" target="_blank"><i
                                    class="fa fa-instagram"> </i></a></li>
                    </ul>
                    <form class="d-inline-block f-right"> </form>
                </div>
            </div>
        </div>
    </div>
</template>